import React from 'react';
import { Flex, Heading, Link, Spacer } from '@chakra-ui/react';

function Navbar() {
  return (
    <Flex as="nav" align="center" justify="space-between" p={4} bg="teal.500" color="white">
      {/* Logo and Text */}
      <Flex align="center">
      <Link href="/about" fontSize="md" mr={4}>
        <Heading as="h1" size="md" mr={4}>
      Summerize.
        </Heading>
        </Link>
      </Flex>
      
      <Spacer />
      
   
      <Link href="https://linkedin.com/in/moezdev" fontSize="md" mr={4}>
        About
      </Link>
    </Flex>
  );
}

export default Navbar;
